import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import { initLegalTransactionRelationshipSkeleton } from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import {
  IMemberTestator,
  TestatorMemberSchema,
} from '../../Members/IMemberTestament';

export const TestamentRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.Testament),
    z.literal(2).optional(),
    z.object({}),
    TestatorMemberSchema
  );

export type ITestamentRelationship = Omit<
  z.infer<typeof TestamentRelationshipSchema>,
  'Members'
> & {
  Members: IMemberTestator[];
};

export function getEmptyTestamentRelationship(): ITestamentRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.Testament,
    data: {},
    Members: [],
  };
}
